import React from 'react';
import { ExternalLink } from 'lucide-react';

export default function VisionStudiosBanner() {
  return (
    <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 py-3 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-2">
          <span className="text-gray-300 text-sm">
            Looking to launch an amazing website like ETWC Ministry?
          </span>
          <a
            href="https://BOLDStudios.io"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white text-sm font-bold hover:text-blue-300 transition-colors inline-flex items-center gap-1"
          >
            Visit us at BOLDStudios.io
            <ExternalLink size={14} />
          </a>
        </div>
      </div>
    </div>
  );
}
